import Datalist from './Datalist.component';

export default Datalist;
